import { render } from "./DiscountCode.vue?vue&type=template&id=e98bfb9a"
import script from "./DiscountCode.vue?vue&type=script&lang=js"
export * from "./DiscountCode.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__